import React from 'react';
import { Field, RichText as JssRichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { getCombinedStyles } from '../../helpers/Providers/bokfDefaultClassNameProvider';

interface Fields {
  Text: Field<string>;
}

export type RichTextProps = {
  params: { [key: string]: string };
  fields: Fields;
};

export const Default = (props: RichTextProps): JSX.Element => {
  const text = props.fields ? (
    <JssRichText field={props.fields.Text} />
  ) : (
    <span className="is-empty-hint">Rich text</span>
  );
  const id = props.params.RenderingIdentifier;

  // Use the helpers to get the correct classes
  const styles = getCombinedStyles(props.params.GridParameters, props.params.Styles);

  return (
    <div className={`bokf-component rich-text ${styles}`} id={id ? id : undefined}>
      <div className="component-content">{text}</div>
    </div>
  );
};
